<template>
  <v-dialog persistent v-model="show" max-width="400">
    <v-card class="pa-2">
      <v-layout class="animated fadeIn delay-0.5s">
        <v-flex>
          <v-text-field
            class="pl-2 pr-3 mt-3"
            prepend-inner-icon="person"
            disabled
            v-model="selectedPersonName"
            v-if="selectedPerson"
            label="Nome"
          ></v-text-field>
          <v-autocomplete
            v-if="!selectedPerson"
            class="pl-2 pr-3 mt-3"
            v-model="task.person"
            :items="items"
            :loading="isLoading"
            color="#099AB1"
            hide-selected
            item-text="description"
            placeholder="Buscar cliente..."
            prepend-icon="search"
            return-object
            :filter="myFilter"
          >
            <template v-slot:item="data">
              <v-list-tile-avatar class="pl-2">
                <div
                  v-lazy-container="{
                    error: 'https://s3.amazonaws.com/konselior/blankwhats.jpg',
                    loading:
                      'https://s3.amazonaws.com/konselior/blankwhats.jpg',
                  }"
                >
                  <img
                    class="avatarImg"
                    :data-src="data.item.celular.whatsapp.picture"
                    v-if="data.item.celular && data.item.celular.whatsapp"
                  />
                  <img
                    class="avatarImg"
                    :data-src="'https://s3.amazonaws.com/konselior/blankwhats.jpg'"
                    v-if="!data.item.celular || !data.item.celular.whatsapp"
                  />
                </div>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title
                  v-html="`${data.item.nome} ${data.item.sobrenome}`"
                  class="alignSelect"
                ></v-list-tile-title>
              </v-list-tile-content>
            </template>
          </v-autocomplete>
        </v-flex>
      </v-layout>
      <v-layout row wrap class="animated fadeIn delay-0.5s">
        <v-flex xs12>
          <v-menu full-width>
            <v-text-field
              :value="formattedDate"
              slot="activator"
              placeholder="Data"
              prepend-inner-icon="fas fa-clock"
              class="px-2 fontResize"
            ></v-text-field>
            <v-date-picker
              v-model="task.due"
              locale="pt-br"
              color="#099AB1"
              width="250"
            ></v-date-picker>
          </v-menu>
        </v-flex>
      </v-layout>
      <v-layout row wrap class="animated fadeIn delay-0.5s">
        <v-flex xs12>
          <v-textarea
            name="input-7-1"
            v-model="task.description"
            value
            prepend-inner-icon="fas fa-tasks"
            class="menuTextbox pl-2 pr-3 pb-1"
            placeholder="Qual é sua próxima tarefa?"
            rows="3"
          ></v-textarea>
        </v-flex>
      </v-layout>
      <v-card-actions class="animated fadeIn delay-0.5s mx-3">
        <v-spacer></v-spacer>

        <v-btn
          round
          small
          outline
          flat="flat"
          class="text-lowercase"
          @click.stop="show = false"
          >cancelar</v-btn
        >

        <v-btn
          round
          small
          depressed
          class="text-lowercase"
          @click="salvarTarefa"
          color="#099AB1"
          dark
          >salvar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import format from 'date-fns/format';
import { mapState, mapActions } from 'vuex';
import { APIService } from '@/resources/campanha.js';
import { EventBus } from '@/event-bus.js';

const api = new APIService();

export default {
  data() {
    return {
      selectedPersonName: null,
      task: {},
      person: null,
      loading: true,
      dt: null,
      isLoading: false,
    };
  },
  computed: {
    items() {
      return this.$store.getters.getClientes.map((entry) => {
        const description = `${entry.nome ? entry.nome : ''} ${
          entry.sobrenome ? entry.sobrenome : ''
        }`;
        return Object.assign({}, entry, { description });
      });
    },
    ...mapState(['agenda']),
    formattedDate() {
      return this.task.due ? format(this.task.due, 'DD/MM/YYYY') : '';
    },
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  props: {
    value: Boolean,
    selectedPerson: Object,
  },

  mounted() {
    if (this.selectedPerson) {
      this.task.person = this.selectedPerson;
      this.selectedPersonName = `${this.selectedPerson.nome} ${this.selectedPerson.sobrenome}`;
    }
  },

  methods: {
    myFilter(obj, a, b) {
      return `${obj.nome} ${obj.sobrenome || ''}`
        .toLowerCase()
        .includes(a.toLowerCase());
    },
    emitSnackBar() {
      const snackBar = {};
      snackBar.text = 'Tarefa agendada com sucesso!';
      snackBar.value = true;
      EventBus.$emit('activeSnackBar', snackBar);
    },
    salvarTarefa() {
      if (this.selectedPerson) { this.task.customerId = this.selectedPerson.customerId; }
      if (!this.selectedPerson) { this.task.customerId = this.task.person.customerId; }
      api.postTask(this.task);
      this.$store.dispatch('carregarPerfil', { user: this.$auth.user });
      this.show = false;
      this.emitSnackBar();
      this.task = '';
    },
  },
};
</script>

<style scoped>
.v-card {
  box-shadow: none;
  border-radius: 10px;
}
.theme--light.v-sheet {
  border: 1px solid #e0e0e0;
}
</style>

<style>
.v-input__append-outer .v-icon,
.v-input__prepend-outer .v-icon {
  font-size: 18px !important;
}
</style>
